export default {
    label_num_entry:{
        en:"Data Entered",
        bn:'ব্যবহারকারীরা'
    },

}